import React, { memo } from 'react';
import './InventoryParamChangeTypeBadge.css';

interface ChangeTypeMeta {
  label: string;
  glyph: string;
  tone: 'positive' | 'negative' | 'warning' | 'critical';
}

export const INVENTORY_CHANGE_TYPE_META: Record<InventoryChangeType, ChangeTypeMeta> = {
  ADDED:           { label: 'ADDED',         glyph: '+', tone: 'positive' },
  UPDATED:         { label: 'UPDATED',       glyph: '↑', tone: 'positive' },
  REPLACED:        { label: 'REPLACED',      glyph: '⇄', tone: 'positive' },
  REMOVED:         { label: 'REMOVED',       glyph: '•', tone: 'critical' },
  INVALID:         { label: 'INVALID',       glyph: '⚠', tone: 'warning'  },
  'CARD REPLACED': { label: 'CARD REPLACED', glyph: '⇄', tone: 'positive' },
  UPGRADED:        { label: 'UPGRADED',      glyph: '↑', tone: 'positive' },
  DOWNGRADED:      { label: 'DOWNGRADED',    glyph: '↓', tone: 'negative' },
};

interface InventoryParamChangeTypeBadgeProps {
  changeType?: InventoryChangeType | null;
}

/** Change type pill shared by the change log card and the Inventory Change History report. */
const InventoryParamChangeTypeBadge = memo(
  function InventoryParamChangeTypeBadge({ changeType }: InventoryParamChangeTypeBadgeProps) {
    const meta = changeType ? INVENTORY_CHANGE_TYPE_META[changeType] : undefined;

    if (!meta) return null;

    return (
      <span className={`inventory__change__type__badge inventory__change__type__badge--${meta.tone}`}>
        <span className='inventory__change__type__badge__glyph' aria-hidden='true'>
          {meta.glyph}
        </span>
        {meta.label}
      </span>
    );
  },
);

export default InventoryParamChangeTypeBadge;
